import React from "react";
import gift from "assets/img/greengift.jpg";
import logo from "assets/img/henry-schein-logo-png-transparent.png";
import sidelogo from "assets/img/HS_Thrive Unlocked__Lockup.png";
import unlock from "assets/img/HS_Thrive Unlocked__K.O.png";

const ConfirmationScreen = () => {
  return (
    <>
      <style>{mobileCss}</style>

      <div style={styles.page}>
        {/* HEADER */}

        <div style={styles.fullHeader}>
          <div className="header-content" style={styles.headerContent}>
            <img
              src={logo}
              style={styles.logo}
              alt="logo"
            />

            <img
              src={sidelogo}
              style={styles.rightLogo}
              alt="sidelogo"
            />
          </div>
        </div>

        {/* CARD */}

        <div style={styles.card}>
          {/* HEADER */}

          <div style={styles.cardHeader}>
            <img
              src={unlock}
              style={styles.unlockLogo}
              alt="unlock"
            />
          </div>

          <div style={styles.content}>
            {/* SUCCESS */}

            <div style={styles.successCircle}>
              ✔
            </div>

            {/* TITLE */}

            <h1 style={styles.title}>
              You’re All Set!
            </h1>

            <p style={styles.subtitle}>
            We’ve received your Thrive Unlocked request.
            </p>

            {/* GREEN BOX */}

            <div
              className="green-box"
              style={styles.greenBox}
            >
              <div style={styles.iconWrapper}>
              <img
              src={gift}
              alt="icon"
              style={styles.infoImage}
            />
              </div>

              <div>
                <div style={styles.greenTitle}>
                You’re on your way to more value.
                </div>

                <div style={styles.greenText}>
                Once approved, your available Thrive Signature benefits and Growth Bonus Rewards will become active.
                </div>
              </div>
            </div>

            {/* WHAT HAPPENS NEXT */}

            <h3 style={styles.sectionTitle}>
            What Happens Next
            </h3>

            <div style={styles.timeline}>
              <Step
                number="1"
                title="Request Submitted"
                desc="We’ve received your Thrive Unlocked enrollment request."
              />

              <Step
                number="2"
                title="Enrollment Review"
                desc="Our team will review your request and confirm your enrollment status by email."
              />

              <Step
                number="3"
                title="Benefits Begin After Approval"
                desc="Once approved, your available Thrive Signature benefits will become active, and you can begin earning Growth Bonus Points."
                 isLast={true}
              />
            </div>

            {/* DIVIDER */}

            <div style={styles.divider}></div>

            {/* FOOTER */}

            <div style={styles.footer}>
              <div style={styles.footerTitle}>
              Need Help?
              </div>

              <div style={styles.footerText}>
                Contact Thrive Support—we’re here
                to help.
              </div>

              <div className="contact-box" style={styles.contact}>
                <span style={styles.link}>
                  1-833-473-4968
                </span>

                <span className="contact-divider">
                  |
                </span>

                <a
                  href="mailto:Thrive.Support@henryschein.com"
                  style={{ color: "#1f5fbf", textDecoration: "none" }}
                >
                  Thrive.Support@henryschein.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

/* STEP */

const Step = ({ number, title, desc, isLast }) => {
  return (
    <div style={styles.stepWrapper}>
      
      {/* LEFT SIDE */}
      <div style={styles.leftSection}>
        
        {/* CIRCLE */}
        <div style={styles.circle}>
          {number}
        </div>

        {/* LINE */}
        {!isLast && <div style={styles.line}></div>}
      </div>

      {/* CONTENT */}
      <div style={styles.stepContent}>
        <div style={styles.stepTitle}>{title}</div>

        <div style={styles.stepDesc}>
          {desc}
        </div>
      </div>
    </div>
  );
};

/* STYLES */

const styles = {
   page: {
  background: "#eef1f5",
  minHeight: "100vh",
  margin: 0,
  padding: "16px",
  fontFamily: "Arial, sans-serif",
  overflowX: "hidden",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
},

  fullHeader: {
  width: "100%",
  maxWidth: "520px",
  background: "#fff",
  padding: "10px 16px",
  boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
  margin: "0 auto 20px auto",
  boxSizing: "border-box",
  borderRadius: "10px",
},

  headerContent: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "12px",
    width: "100%",
  },

  logo: {
    width: "120px",
    maxWidth: "45%",
    objectFit: "contain",
  },

  rightLogo: {
    width: "190px",
    maxWidth: "50%",
    objectFit: "contain",
  },

  card: {
    width: "100%",
    maxWidth: "520px",
    margin: "0 auto",
    background: "#fff",
    borderRadius: "14px",
    boxShadow:
      "0 6px 18px rgba(0,0,0,0.12)",
    overflow: "hidden",
  },

  cardHeader: {
    background: "#0A72BA",
    textAlign: "center",
    // padding: "10px",
  },

  unlockLogo: {
    width: "100%",
    maxWidth: "260px",
    objectFit: "contain",
  },

  content: {
    padding: "22px 18px",
  },

  successCircle: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    border: "2px solid green",
    color: "green",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "28px",
    margin: "0 auto 15px",
  },

  title: {
    textAlign: "center",
    color: "#0E176D",
    marginBottom: "5px",
    fontSize: "30px",
  },

  subtitle: {
    textAlign: "center",
    color: "#343F88",
    marginBottom: "20px",
    lineHeight: "22px",
    fontSize: "14px",
  },

  greenBox: {
    border: "2px solid #22c55e",
    borderRadius: "12px",
    padding: "15px",
    display: "flex",
    alignItems: "center",
    gap: "15px",
    marginBottom: "20px",
  },

  greenIcon: {
    width: "55px",
    height: "55px",
    borderRadius: "47%",
    border: "2px solid #22c55e",
    padding: "9px",
    objectFit: "cover",
    flexShrink: 0,
  },

  greenTitle: {
    color: "#16a34a",
    fontWeight: "bold",
    marginBottom: "5px",
    fontSize: "15px",
  },

  greenText: {
    fontSize: "13px",
    color: "#343F88",
    lineHeight: "20px",
  },

  sectionTitle: {
    marginTop: "15px",
    marginBottom: "15px",
    color: "#1d2b53",
    fontWeight: "bold",
    fontSize: "20px",
  },

  timeline: {
    marginTop: "10px",
  },

  stepRow: {
    display: "flex",
    gap: "12px",
    marginBottom: "20px",
  },

  stepLeft: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  stepCircle: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    background: "#e6effc",
    color: "#1f5fbf",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "bold",
    flexShrink: 0,
  },

  stepLine: {
    width: "2px",
    height: "55px",
    background: "#dbe3f0",
    marginTop: "2px",
  },

  stepContent: {
    flex: 1,
  },

  stepTitle: {
    fontWeight: "bold",
    marginBottom: "4px",
    color: "#0E176D",
    fontSize: "15px",
  },

  stepDesc: {
    fontSize: "13px",
    color: "#343F88",
    lineHeight: "20px",
  },

  divider: {
    height: "1px",
    background: "#e5e7eb",
    margin: "20px 0",
  },

  footer: {
    textAlign: "left",
  },

  footerTitle: {
    fontWeight: "bold",
    marginBottom: "5px",
    color: "#0E176D",
  },

  footerText: {
    fontSize: "12px",
    marginBottom: "10px",
    color: "#343F88",
  },

  contact: {
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
    gap: "6px",
  },

  link: {
    color: "#2563eb",
    cursor: "pointer",
    wordBreak: "break-word",
  },

  iconWrapper: {
  width: "60px",
  height: "60px",
  minWidth: "60px",
  borderRadius: "29px",
  background: "#fff",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  border: "2px solid #22c55e",
},

infoImage: {
  width: "38px",
  height: "30px",
  objectFit: "contain",
},

timeline: {
  marginTop: "20px",
},

stepWrapper: {
  display: "flex",
  alignItems: "flex-start",
  position: "relative",
},

leftSection: {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  marginRight: "16px",
},

circle: {
  width: "36px",
  height: "36px",
  borderRadius: "50%",
  background: "#e8f0fb",
  color: "#2563eb",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontWeight: 600,
  fontSize: "14px",
  zIndex: 2,
},

line: {
  width: "2px",
  flex: 1,
  minHeight: "75px",
  background: "#dbe4f0",
  marginTop: "0px",
},

stepContent: {
  paddingBottom: "28px",
  flex: 1,
},

stepTitle: {
  fontWeight: 700,
  color: "#0E176D",
  marginBottom: "6px",
  fontSize: "18px",
},

stepDesc: {
  color: "#343F88",
  fontSize: "14px",
  lineHeight: "22px",
},
stepWrapper: {
  display: "flex",
  alignItems: "flex-start",
},

};

/* MOBILE CSS */

const mobileCss = `
*{
  box-sizing:border-box;
}

body {
  margin:0;
  padding:0;
  overflow-x:hidden;
}

@media only screen and (max-width: 768px) {

  .header-content{
    display:flex !important;
    flex-direction:row !important;
    justify-content:space-between !important;
    align-items:center !important;
    flex-wrap:nowrap !important;
  }

  .green-box{
    flex-direction:column !important;
    text-align:center;
  }

  .contact-box{
    flex-direction:column !important;
    align-items:flex-start !important;
    gap:8px !important;
  }

  .contact-divider{
    display:none;
  }
}

@media only screen and (max-width: 480px) {

  h1{
    font-size:24px !important;
  }

  .header-content img:first-child{
    width:100px !important;
    max-width:42% !important;
  }

  .header-content img:last-child{
    width:150px !important;
    max-width:52% !important;
  }
}
`;

export default ConfirmationScreen;